import React from 'react';
import './styles/appSpinner.scss'

function AppSpinner() {
  return (
    <div className="loader center"></div>
  );
}

export default AppSpinner;
